import { createContext } from 'react';

interface ProjectContextValue {
  orgId: string | null;
  selectedProjectId: string | null;
  onProjectChange: (id: string) => void;
}

const ProjectContext = createContext<ProjectContextValue>({
  orgId: null,
  selectedProjectId: null,
  onProjectChange: () => {},
});

export default ProjectContext;
